import React from 'react'
import { Navigation, Clients } from 'components'

export default () => (
  <>
    <Navigation type="admin" />
    <Clients />
  </>
)
